import { createSlice } from "@reduxjs/toolkit";

const validateuserState = {
  validateuserdata: {}
}

const validateuserSlice = createSlice({
  name: "validateuser",
  initialState: validateuserState,
  reducers: {
    validUserData: (state, action ) => action.payload,
    DeleteValidUserData : (state, action) => {
      state.validateuserdata = action.payload;
    }
  },
});

export const { validUserData } = validateuserSlice.actions;

export default validateuserSlice.reducer;